/**
 * Shared UI utility functions
 * @copyright reDim GmbH | @link https://www.redim.de | @contact team@redim.de
 */

/**
 * Escapes HTML special characters to prevent XSS
 * @param {string} str - Raw string
 * @returns {string} HTML-escaped string
 */
export function escapeHtml(str) {
    if (!str) return '';
    return String(str)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;');
}
